import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard-overview-title flex gap-[16px] justify-between flex-nowrap" }
const _hoisted_2 = { class: "flex flex-grow flex-col" }
const _hoisted_3 = { class: "gordita-400-13 text-Text/text_medium" }
const _hoisted_4 = { class: "gordita-500-20-m text-Text/text_high" }


export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard-overview-title',
  props: {
    title: null,
    value: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.value), 1)
    ])
  ]))
}
}

})